<script lang="ts" setup>
import { computed } from 'vue'
import { AlertVariant } from './types'

interface AlertProps {
  variant?: keyof typeof AlertVariant
}

const props = withDefaults(defineProps<AlertProps>(), {
  variant: AlertVariant.default,
})

const variantClass = computed((): string => {
  switch (props.variant) {
    case AlertVariant.blue:
      return 'border-blue-100 bg-blue-50 text-blue-700'
    case AlertVariant.green:
      return 'border-green-100 bg-green-50 text-green-700'
    case AlertVariant.red:
      return 'border-red-100 bg-red-50 text-red-700'
    case AlertVariant.yellow:
      return 'border-yellow-200 bg-yellow-50 text-yellow-700'
    case AlertVariant.default:
    default:
      return 'bg-white text-gray-700'
  }
})

const alertClass = computed((): string[] => {
  const base = [
    'py-3',
    'px-5',
    'flex',
    'items-center',
    'justify-start',
    'gap-2.5',
    'rounded-lg',
    'border',
    'text-sm',
  ]
  return [...base, variantClass.value]
})
</script>

<template>
  <div :class="alertClass">
    <slot />
  </div>
</template>
